<app-service-not-available [description]="serviceNotAvailableDesc"></app-service-not-available>